import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-45f5e3c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 0 }
const _hoisted_5 = {
  href: "https://admin-manual.kas-security.jp",
  target: "_blank"
}
const _hoisted_6 = {
  href: "https://user-manual.kas-security.jp",
  target: "_blank"
}
const _hoisted_7 = {
  href: "https://www.kas-security.jp/support",
  target: "_blank"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["href"]
const _hoisted_12 = { key: 3 }
const _hoisted_13 = {
  href: "http://www.datarv.cn/",
  target: "_blank"
}

import { computed, ref } from 'vue'
import { TOP_DOMAIN_CONFIG } from '@/config/top-domain'
import { IS_MING_TING_SUBJECT } from '@/project-subject/project-subject'
import { IS_PRIVATE } from '@/common/const/env'
import { IS_JP_ONLY_BUILD } from '@/common/const/build-locale'
import { user } from '@/common/basis/root-injector'


export default /*#__PURE__*/_defineComponent({
  __name: 'footer',
  setup(__props) {

const currentYear = computed(() => new Date().getFullYear())

/** 日版手册链接仅登录后展示 */
const isLogin = ref(user.hasUser())
user.userInfo.subscribe(() => {
  isLogin.value = user.hasUser()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", null, _toDisplayString(_ctx.$t('footer.aboutProduct')) + " ｜ ", 1),
    _createElementVNode("a", {
      href: _unref(IS_JP_ONLY_BUILD)?'https://www.kas-security.jp/eula' : '/privacy/dubateamLicenseandserviceterms.html',
      target: "_blank"
    }, _toDisplayString(_ctx.$t('footer.licenseAndService')), 9, _hoisted_2),
    _createTextVNode(" ｜ "),
    _createElementVNode("a", {
      href: _unref(IS_JP_ONLY_BUILD)?'https://www.kingsoft.jp/protection': '/privacy/dubateamPrivacy.html',
      target: "_blank"
    }, _toDisplayString(_ctx.$t('footer.privacy')), 9, _hoisted_3),
    (_unref(IS_JP_ONLY_BUILD) && isLogin.value)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
          _createTextVNode(" ｜ "),
          _createElementVNode("a", _hoisted_5, _toDisplayString(_ctx.$t('footer.adminManual')), 1),
          _createTextVNode(" ｜ "),
          _createElementVNode("a", _hoisted_6, _toDisplayString(_ctx.$t('footer.userManual')), 1),
          _createTextVNode(" ｜ "),
          _createElementVNode("a", _hoisted_7, _toDisplayString(_ctx.$t('footer.support')), 1)
        ]))
      : _createCommentVNode("", true),
    (!_unref(IS_PRIVATE))
      ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
          (!_unref(IS_JP_ONLY_BUILD))
            ? (_openBlock(), _createElementBlock("span", _hoisted_9, " ｜ " + _toDisplayString(_ctx.$t('footer.copyright', { year: currentYear.value })), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_10, " ｜ Copyright ©︎ キングソフト株式会社.")),
          (!_unref(IS_JP_ONLY_BUILD))
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                href: _unref(TOP_DOMAIN_CONFIG).jump_url,
                target: "_blank"
              }, " " + _toDisplayString(_unref(TOP_DOMAIN_CONFIG).display_name) + " ", 9, _hoisted_11))
            : _createCommentVNode("", true),
          _createElementVNode("span", null, " " + _toDisplayString(_ctx.$t('footer.allRightsReserved')), 1),
          (_unref(IS_MING_TING_SUBJECT) && !_unref(IS_JP_ONLY_BUILD))
            ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                _createTextVNode(" ｜ "),
                _createElementVNode("a", _hoisted_13, _toDisplayString(_ctx.$t('footer.dataRecovery')), 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})